document.addEventListener('DOMContentLoaded', () => {
  const labels = document.querySelectorAll('label.font-select');
  
  labels.forEach(label => {
    label.addEventListener('click', () => {
      // Remove 'clicked' class from all labels first
      labels.forEach(otherLabel => {
        otherLabel.classList.remove('clicked');
      });
      
      // Add a class name when label is clicked
      label.classList.add('clicked');
    });
  });
});

  const modalCalendly = document.getElementById("modalPopupCalendly");
  const modalEmbroidery = document.getElementById("modalPopupEmbroidery");
  const modalEngraved = document.getElementById("modalPopupEngraved");
  const modalPerfect = document.getElementById("modalPopupPerfect");
  const modalDetails = document.getElementById("modalPopupDetails");
  const modalVideo = document.getElementById("modalVideo");

  const closeButtonCalendly = document.querySelector(".close-buttonCalendly");
  const closeButtonEmbroidery = document.querySelector(".close-buttonEmbroidery");
  const closeButtonEngraved = document.querySelector(".close-buttonEngraved");
  const closeButtonPerfect = document.querySelector(".close-buttonPerfect");
  const closeButtonDetails = document.querySelector(".close-buttonDetails");
  const closeButtonVideo = document.querySelector(".close-buttonVideo");

  const openModalButtonCalendly = document.getElementById("openModalCalendly");
  const openModalButtonEmbroidery = document.getElementById("openModalEmbroidery");
  const openModalButtonEngraved = document.getElementById("openModalEngraved");
  const openModalButtonPerfect = document.getElementById("openModalPerfect");
  const openModalButtonDetails = document.getElementById("openModalDetails");
  const openModalButtonVideo1 = document.getElementById("openModalVideo1");
  const openModalButtonVideo2 = document.getElementById("openModalVideo2");
  const openModalButtonVideo3 = document.getElementById("openModalVideo3");

  closeButtonCalendly.addEventListener("click", () => {
    modalCalendly.style.display = "none";
  }); 

  closeButtonEmbroidery.addEventListener("click", () => {
    modalEmbroidery.style.display = "none";
  });

  closeButtonEngraved.addEventListener("click", () => {
    modalEngraved.style.display = "none";
  });

  closeButtonPerfect.addEventListener("click", () => {
    modalPerfect.style.display = "none";
  });

  closeButtonDetails.addEventListener("click", () => {
    modalDetails.style.display = "none";
  });

  closeButtonVideo.addEventListener("click", () => {
    modalVideo.style.display = "none";
  });

  
  window.addEventListener("click", (event) => {
    if (event.target === modalCalendly) {
      modalCalendly.style.display = "none";
    
    }
  });

  window.addEventListener("click", (event) => {
    if (event.target === modalEmbroidery) {
      modalEmbroidery.style.display = "none";
    
    }
  });

  window.addEventListener("click", (event) => {
    if (event.target === modalEngraved) {
      modalEngraved.style.display = "none";
    
    }
  });

  window.addEventListener("click", (event) => {
    if (event.target === modalPerfect) {
      modalPerfect.style.display = "none";
    
    }
  });

  window.addEventListener("click", (event) => {
    if (event.target === modalDetails) {
      modalDetails.style.display = "none";
    
    }
  });

  window.addEventListener("click", (event) => {
    if (event.target === modalVideo) {
      modalVideo.style.display = "none";
    
    }
  });


  // Function to open the modal

  openModalButtonCalendly.addEventListener("click", () => {
    modalCalendly.style.display = "block";
  });

  openModalButtonEmbroidery.addEventListener("click", () => {
    modalEmbroidery.style.display = "block";
  });

  openModalButtonEngraved.addEventListener("click", () => {
    modalEngraved.style.display = "block";
  });

  openModalButtonPerfect.addEventListener("click", () => {
    modalPerfect.style.display = "block";
  });

  openModalButtonDetails.addEventListener("click", () => {
    modalDetails.style.display = "block";
  });

  openModalButtonVideo1.addEventListener("click", () => {
    modalVideo.style.display = "block";
  });

   openModalButtonVideo2.addEventListener("click", () => {
    modalVideo.style.display = "block";
  });

  openModalButtonVideo3.addEventListener("click", () => {
    modalVideo.style.display = "block";
  });




document.addEventListener('DOMContentLoaded', function() {
  
    const bustInput = document.getElementById('bust');
    const bustDiv = document.getElementById('info-bust');

    const waistInput = document.getElementById('waist');
    const waistDiv = document.getElementById('info-waist');

    const shoulderInput = document.getElementById('shoulder');
    const shoulderDiv = document.getElementById('info-shoulder');

    const heightInput = document.getElementById('height');
    const heightDiv = document.getElementById('info-height');
  
  
    const color_div = document.getElementById('colors-content-product');
    const color_click = document.getElementById('colors-content');

    color_click.addEventListener('click', () => {
    if (color_div.style.display === 'block') {
        color_div.style.display = 'none';
    } else {
        color_div.style.display = 'block';
    }
    });
  
    const perfect_fit_div = document.getElementById('Perfect-fit');
    const perfect_fit_click = document.getElementById('Perfect-fit-content');

    perfect_fit_click.addEventListener('click', () => {
    if (perfect_fit_div.style.display === 'block') {
        perfect_fit_div.style.display = 'none';
    } else {
        perfect_fit_div.style.display = 'block';
    }
    });
  
    const engrave_cuff_div = document.getElementById('Engraved-cuff');
    const engrave_cuff_click = document.getElementById('Engraved-cuff-Content');

    engrave_cuff_click.addEventListener('click', () => {
    if (engrave_cuff_div.style.display === 'block') {
        engrave_cuff_div.style.display = 'none';
    } else {
        engrave_cuff_div.style.display = 'block';
    }
    });
  
  
    const Embroi_div = document.getElementById('Embroidery-content');
    const Embroi_click = document.getElementById('Embroidery-content-click');
  
    Embroi_click.addEventListener('click', () => {
    if (Embroi_div.style.display === 'block') {
        Embroi_div.style.display = 'none';
    } else {
        Embroi_div.style.display = 'block';
    }
    });


   
  
    
    // Show the div when the input is hovered over
    bustInput.addEventListener('mouseenter', () => {
        bustDiv.style.display = 'block';
    });
  
    bustInput.addEventListener('mouseleave', () => {
        if (bustInput.value.length <= 1) {
            bustDiv.style.display = 'none';
        }
    });

      // Show the div when the input is hovered over
    waistInput.addEventListener('mouseenter', () => {
        waistDiv.style.display = 'block';
    });
  
    waistInput.addEventListener('mouseleave', () => {
        if (waistInput.value.length <= 1) {
            waistDiv.style.display = 'none';
        }
    });

     // Show the div when the input is hovered over
    shoulderInput.addEventListener('mouseenter', () => {
        shoulderDiv.style.display = 'block';
    });
    shoulderInput.addEventListener('mouseleave', () => {
        if (shoulderInput.value.length <= 1) {
            shoulderDiv.style.display = 'none';
        }
    });


     // Show the div when the input is hovered over
    heightInput.addEventListener('mouseenter', () => {
        heightDiv.style.display = 'block';
    });
    heightInput.addEventListener('mouseleave', () => {
        if (heightInput.value.length <= 1) {
            heightDiv.style.display = 'none';
        }
    });

  
});



document.getElementById('Embroidery').addEventListener('input', function() {
    checkInputLength(this);
});
document.getElementById("Embroidery").addEventListener("input", function() {
    if (this.value.length > 15) {
        this.value = this.value.slice(0, 15);
    }
});



 function checkInputLength(input) {
       const warningDiv = document.getElementById('warning');
      if (input.value.length > 15) {
         warningDiv.style.display = 'block';
    } else {
        warningDiv.style.display = 'none';
    }
}

document.getElementById('Embroidery').addEventListener('input', function() {
    checkInputLength(this);
});
document.getElementById("Embroidery").addEventListener("input", function() {
    if (this.value.length > 15) {
        this.value = this.value.slice(0, 15);
    }
});

const divs = document.querySelectorAll('.block');
const maxSelected = 3;

// Create and append radio inputs for each div
divs.forEach((div, index) => {
    const radio = document.createElement('input');
    radio.type = 'radio';
    radio.name = 'blockRadio';
    radio.id = `radio${index}`;
    radio.disabled = true; // Initially disabled
    
    const label = document.createElement('label');
    label.htmlFor = `radio${index}`;
    label.textContent = `Option ${index + 1}`;
    
    div.appendChild(radio);
    div.appendChild(label);
});

// Add click handler to each div
divs.forEach(div => {
    div.addEventListener('click', () => {
        const activeElements = document.querySelectorAll('.block.active');
        const radio = div.querySelector('input[type="radio"]');
        
        if (!div.classList.contains('active')) {
            if (activeElements.length < maxSelected) {
               div.classList.add('active');
                radio.disabled = false; // Enable radio when div is active
                radio.checked = true; // Auto-check radio when div is selected
            }
        } else {
            div.classList.remove('active');
            radio.disabled = true; // Disable radio when div is inactive
            radio.checked = false;
        }
    });
 });


// Fonts

 const divsfont = document.querySelectorAll('.block-fonts');
 const maxSelectedfont = 1;

// Create and append radio inputs for each div
 divsfont.forEach((div, index) => {
    const radiofont = document.createElement('input');
    radiofont.type = 'radio';
    radiofont.name = 'blockRadio';
    radiofont.id = `radio${index}`;
    radiofont.disabled = true; // Initially disabled
    
    const labelfont = document.createElement('label');
    labelfont.htmlFor = `radio${index}`;
    labelfont.textContent = `Option ${index + 1}`;
    
    div.appendChild(radiofont);
    div.appendChild(labelfont);
 });

// Add click handler to each div
  divsfont.forEach(div => {
    div.addEventListener('click', () => {
        const activeElementsfont = document.querySelectorAll('.block-fonts.active');
        const radiofont = div.querySelector('input[type="radio"]');

       if (!div.classList.contains('active')) {
            if (activeElementsfont.length < maxSelectedfont) {
                div.classList.add('active');
                radiofont.disabled = false; // Enable radio when div is active
                radiofont.checked = true; // Auto-check radio when div is selected
            }
        } else {
            div.classList.remove('active');
            radiofont.disabled = true; // Disable radio when div is inactive
            radiofont.checked = false;
        }
    });
});

    
// Add deselect all functionality
const deselectButton = document.createElement('button');
deselectButton.textContent = 'Deselect All';
deselectButton.addEventListener('click', () => {
    const activeElements = document.querySelectorAll('.block.active');
    activeElements.forEach(element => {
        element.classList.remove('active');
        const radio = element.querySelector('input[type="radio"]');
        radio.disabled = true;
        radio.checked = false;
    });
});
document.body.appendChild(deselectButton);

const addToCartButton = document.querySelectorAll('.t4s-product-form__submit');
const requiredInputs = document.querySelectorAll('.required');

    const validateForm = () => {
        let isValid = true;
        requiredInputs.forEach(input => {
            if (!input.value.trim()) {
                isValid = false;
            }
        });
        
        addToCartButton.disabled = !isValid;
    };

    // Check on input change
    requiredInputs.forEach(input => {
        input.addEventListener('input', validateForm);
    });

    // Initial check
    validateForm();